module.exports = __webpack_public_path__ + "static/img/case3.73778623.png";